import Vue from 'vue'
import _ from 'underscore'

export default {

    namespaced: true,

    state: {

        data: {}

    },

    getters: {

        all: function(state) {

            return state.data

        },

        overview: function(state) {

            return state.data.overview || {}

        },

        timeline: function(state) {

            return state.data.timeline || {}

        },

        arrivals: function(state) {

            return state.data.arrivals || []

        },

        arrivalsTotal: function(state) {

            return state.data.arrivalsTotal || 0

        },

        compare: function(state) {

            return state.data.compare || {}

        },

        universe: function(state) {

            return state.data.universe || {}

        },

        universeList: function(state) {

            return state.data.universeList || []

        },

        universeListTotal: function(state) {

            return state.data.universeListTotal || 0

        }

    },

    mutations: {

        reset: function(state) {

            state.data = {}

        },

        set: function(state, data) {

            _.each(data, function(value, key) {

                Vue.set(state.data, key, value)

            })

        }

    },

    actions: {}

}
